<div class="arrival">
  <div class="arrival__header">Arrival</div>
  <ul class="sgl-timeline">
    @for (arrival of dates; track arrival.label) {
      <li class="sgl-timeline__item">
        <div class="arrival__label">{{ arrival.label }}</div>
        <span>{{ arrival.value | dateTimeFormat }}</span>
      </li>
    }
  </ul>
</div>
